
export default {
    namespaced: true,
    state: {
        dialog: false,
        editandoTipoUsuario: false,
        tiposUsuarios: [],
        tipoUsuario: []
    },
    mutations: {
        SET_DIALOG(state, mostrar){
            state.dialog = mostrar
        },
        SET_TIPOSUSUARIOS(state, tiposUsuarios){
            tiposUsuarios.forEach(tipoUsuario => {
                tipoUsuario.estado = tipoUsuario.habilitado ? 'Habilitado' : 'Deshabilitado';
            });
            state.tiposUsuarios = tiposUsuarios
        },
        SET_TIPOUSUARIO(state, tipoUsuario){
            state.editandoTipoUsuario = true;
            state.tipoUsuario = tipoUsuario;
        },
        SET_NUEVOTIPOUSUARIO(state){
            state.editandoTipoUsuario = false;
            state.tipoUsuario = {
                nombre: '',
                habilitado: 1,
                valor: 1,
                observaciones: ''
            };
            state.dialog = true;
        }
    },
    actions: {
        setDialog({commit}, mostrar){
            commit('SET_DIALOG', mostrar);
        },
        setTiposUsuarios({commit}, tiposUsuarios){
            commit('SET_TIPOSUSUARIOS', tiposUsuarios);
        },
        setTipoUsuario({commit}, tipoUsuario){
            commit('SET_TIPOUSUARIO', tipoUsuario);
        },
        setNuevoTipoUsuario({commit}){
            commit('SET_NUEVOTIPOUSUARIO');
        },
    }
}